module.exports = __webpack_public_path__ + "static/img/icon_del.607f1ba0.png";